var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.8,17.4H4.2c-1,0-1.6,0-2.1-0.3C1.6,16.9,1.2,16.5,1,16c-0.3-0.5-0.3-1.1-0.3-2.1V5.9c0-1,0-1.6,0.3-2.1 c0.2-0.5,0.6-0.8,1.1-1.1c0.5-0.3,1-0.3,2-0.3V1.5c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8v0.9h6.8V1.5c0-0.4,0.3-0.8,0.8-0.8 s0.8,0.3,0.8,0.8v0.9c1,0,1.5,0,2,0.3c0.5,0.2,0.8,0.6,1.1,1.1c0.3,0.5,0.3,1.1,0.3,2.1v8.1c0,1,0,1.6-0.3,2.1 c-0.2,0.5-0.6,0.8-1.1,1.1C15.4,17.4,14.9,17.4,13.8,17.4z M4.2,3.9c-0.8,0-1.2,0-1.4,0.1C2.6,4.1,2.4,4.3,2.4,4.4 C2.2,4.6,2.2,5.1,2.2,5.9v8.1c0,0.8,0,1.2,0.1,1.4c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.7,0.1,1.4,0.1h9.7c0.8,0,1.2,0,1.4-0.1 c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.7,0.1-1.4V5.9c0-0.8,0-1.2-0.1-1.4c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.7-0.1-1.4-0.1H4.2 z M9,11.5H4.8c-0.4,0-0.8-0.3-0.8-0.8S4.4,10,4.8,10H9c0.4,0,0.8,0.3,0.8,0.8S9.4,11.5,9,11.5z M13.2,8.1H4.8 c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8h8.3c0.4,0,0.8,0.3,0.8,0.8S13.6,8.1,13.2,8.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b58911bda1dd1925bd4153052d9bc40e.svg";
export { ForwardRef as ReactComponent };